export { AdminAuth } from './admin-auth.service';
export { Auth } from './auth.service';
export { AUTH_CONFIG, ADMIN_AUTH_CONFIG } from './auth.config';
export {
  AuthConfig,
  AuthServiceInterface,
  AuthState,
  CrossDomainSSODomainsGetResultAjax,
} from './auth.interface';
